
import { Injectable } from '@angular/core';
import {
   HttpEvent,
   HttpHandler,
   HttpInterceptor,
   HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { from } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { SilentRequest } from '@azure/msal-browser';
import { ConfigService } from '../configHelper';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private msalService: MsalService, private configService: ConfigService) { }

   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return from(this.handleAccess(request, next));
   }

   private async handleAccess(request: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
      const medtekApi: string = this.configService.getConfig().mtApiURL;

     if (request.url.indexOf(medtekApi) == -1) {

       const account = this.msalService.instance.getAllAccounts()[0]; 
       const apiClientId = this.configService.getConfig().entraAPIClientId;

       if (account) {
         const silentRequest: SilentRequest = {
           scopes: [`api://${apiClientId}/access_as_user`], 
           account: account,
           redirectUri: `${this.configService.getConfig().entraRedirectURL}assets/blank.json`
         };

         try {
           const response = await this.msalService.instance.acquireTokenSilent(silentRequest);
           console.log("silent tokenResponse", response);
           request = request.clone({
             setHeaders: {
               Authorization: 'Bearer ' + response.accessToken
             }
           });
         } catch (error) {
           console.error('acquireTokenSilent failed:', error);
           const redirectRequest: SilentRequest = {
             scopes: [`api://${apiClientId}/access_as_user`],
             account: account,
             state: window.location.host.toLowerCase(),
             redirectUri: `${this.configService.getConfig().entraRedirectURL}auth/callback`
           };

           console.log("redirecting to acquire refreshed token");
           await this.msalService.instance.acquireTokenRedirect(redirectRequest);
         }

       }
     }
     else {
         const medtekToken: any = this.configService.getConfig().mtApiToken;
         request = request.clone({
            setHeaders: {
               Authorization: 'Bearer ' + medtekToken
            }
         });
      }
      return next.handle(request).toPromise();
   }
}
